import { formatDatePublish } from 'app/shared/utils/utils';

export class NewspaperPdf {
  static fromObject(newspaperPdf: object): NewspaperPdf {
    return new NewspaperPdf(
      newspaperPdf['access'],
      newspaperPdf['newspaperPdf_id'],
      newspaperPdf['newspaper_name'],
      newspaperPdf['newspaper_subname'],
      newspaperPdf['publish_number'],
      newspaperPdf['publish_on'],
      newspaperPdf['image_url'],
      newspaperPdf['pdf_url'],
      newspaperPdf['pdf_id'],
      newspaperPdf['thumbnail_big'],
      newspaperPdf['thumbnail_small'],
      newspaperPdf['landscape'],
      newspaperPdf['direct_download']
    );
  }

  constructor(
    public access: boolean,
    public newspaperPdf_id: number,
    public newspaper_name: string,
    public newspaper_subname: string,
    public publish_number: number,
    public publish_on: string,
    public image_url: string,
    public pdf_url: string,
    public pdf_id: number,
    public thumbnail_big: string,
    public thumbnail_small: string,
    public landscape: boolean,
    public direct_download: boolean
  ) {}

  get publish_date() {
    return formatDatePublish(this.publish_on);
  }
}
